export const LARGE_FONT_ZOOM_RATIO = 1.5

/** URL 参数 font=large 时页面整体放大 150% */
export function isLargeFontMode(query: Record<string, unknown> | undefined | null): boolean {
  return String(query?.font || 'small') === 'large'
}

/** 挂到 body 的弹层反缩放，抵消 documentElement zoom */
export function getLargeFontZoomCompensatePercent(): string {
  return `${100 / LARGE_FONT_ZOOM_RATIO}%`
}
